'use client'

import { useState, useEffect, useMemo, useCallback } from 'react'
import store from 'store'
import en from '../../../locales/en'
import ja from '../../../locales/ja'

// i18n設定を直接定義
const i18nConfig = {
  defaultLocale: 'ja',
  locales: ['en', 'ja'],
}

// ストアのキー
const STORE_KEY_LOCALE = 'locale'

export const useLocale = () => {
  // 初期値としてデフォルトロケールを使用
  const [locale, setLocale] = useState(i18nConfig.defaultLocale)

  // 副作用を使用してブラウザ環境でのロケール設定を取得
  useEffect(() => {
    if (typeof window === 'undefined') return

    // storeからロケールを取得
    const savedLocale = store.get(STORE_KEY_LOCALE)
    if (savedLocale && i18nConfig.locales.includes(savedLocale as any)) {
      setLocale(savedLocale)
      return
    }

    // ブラウザの言語設定を確認
    const browserLang = navigator.language.split('-')[0]
    if (i18nConfig.locales.includes(browserLang as any)) {
      setLocale(browserLang)
    }
  }, []) // 空の依存配列で初回レンダリング時のみ実行

  // ロケールを変更するメソッド
  const onChangeLang = useCallback((selectedLang: string) => {
    if (i18nConfig.locales.includes(selectedLang as any)) {
      // storeにロケールを保存
      store.set(STORE_KEY_LOCALE, selectedLang)
      setLocale(selectedLang)

      // ページをリロードして変更を反映
      if (typeof window !== 'undefined') {
        window.location.reload()
      }
    }
  }, [])

  // ロケールに基づいて翻訳オブジェクトをメモ化
  const t = useMemo(() => {
    return locale === 'ja' ? ja : en
  }, [locale])

  return { locale, t, onChangeLang }
}
